import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("App error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#1A3626",
            color: "#FDFBF7",
            fontFamily: "Manrope, sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "42px", margin: 0 }}>
            Travel Bug India
          </h1>
          <p style={{ opacity: 0.8, marginTop: "12px", maxWidth: "420px" }}>
            Something went wrong loading this page. Please refresh to continue exploring India.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "24px",
              background: "#C19A5B",
              color: "#1A3626",
              border: "none",
              borderRadius: "999px",
              padding: "14px 28px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
